import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Card, Avatar, ConfigProvider, Popconfirm, Button, Col, Row, message, Table, Checkbox, Tab, Carousel } from "antd";
import { DeleteOutlined, EditOutlined, UserOutlined, MoreOutlined, HistoryOutlined } from '@ant-design/icons';
import moment from 'moment';
import Label_language from '../../../language';
import PreviewImgModal from "./PreviewImgModal";
import PreviewVideoModal from "./PreviewVideoModal";
import PreviewModal from "./PreviewModal";
import PreviewPdfModal from "./PreviewPdfModal";
import PreviewWordModal from "./PreviewWordModal";
import PreviewMp3Modal from "./PreviewMp3Modal";
import PreviewPPTModal from "./PreviewPPTModal";
const label_language = Label_language.cramschool.children;
const MediaList = ({
    page = 1,
    setPage = () => { },
    data = [],
    setData = () => { },
    handleEdit = () => { },
    handleDeleteRow = () => { },
    reloadPage = () => { },
    total = 0,
    handleOnChange = () => { },
    get_data = () => { },
    loading = false,
    setLoading = () => { },
}) => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [messageApi, contextHolder] = message.useMessage();
    const [modal_mp3, set_modal_mp3] = useState(false);
    const [content, setContent] = useState('')
    const [modal_word, set_modal_word] = useState(false);
    const [modal_pdf, set_modal_pdf] = useState(false);
    const [modal_ppt, set_modal_ppt] = useState(false);
    const [type, set_type] = useState(null);
    const [modal_file, set_modal_file] = useState(false)
    const [modal_img, set_modal_img] = useState(false);
    const [url, setUrl] = useState('');
    const [dataurl, setDataUrl] = useState('');
    const [file, set_file] = useState();
    const [modal_video, set_modal_video] = useState(false);
    const [dataTmp, setDataTmp] = useState([])
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    // 检测滚动事件，当滚动到底部时触发加载更多数据
    const handleScroll = () => {
        const { clientHeight, scrollHeight, scrollTop } = document.documentElement;
        if (scrollHeight - scrollTop === clientHeight) {
            loadMoreData();
        }
    };

    // useEffect(() => {
    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);
    const loadMoreData = () => {
        setLoading(true);
        get_data(page + 1);
        setPage((prevPage) => prevPage + 1);
    }
    const handlePreview = (file_type, type, item) => {
        set_file(item);
        setUrl(null);
        // console.log(type);
        if (file_type == 'pic') {
            setUrl(item.file_url);
            // console.log(item.file_url);
            set_modal_img(true);
        } else {
            if (file_type != 'video') {
                axios
                    .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": item.file_id } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/png",// this is the only MIME for SVG
                        });
                        // console.log(blob_);
                        var reader = new FileReader();
                        reader.readAsDataURL(blob_);
                        reader.onloadend = function () {
                            var base64String = reader.result;
                            // console.log(base64String);
                            setUrl(base64String);
                        }
                        const dataurl = URL.createObjectURL(blob_);
                        setDataUrl(dataurl);
                    })
            }
            if (file_type == 'video') {
                var videodataurl = '';
                // axios
                //     .get('/media/api/classify_structure_type_file_video', {
                //         responseType: 'blob',
                //         params: {
                //             file_id: item.file_id
                //         }
                //     })
                //     .then((response) => {
                //         videodataurl = window.URL.createObjectURL(new Blob([response.data]));
                //     })
                videodataurl = `${axios.defaults.baseURL}/media/api/classify_structure_type_file_video?file_id=${item["file_id"]}`;
                setDataUrl(videodataurl)
                set_modal_video(true);
            } else if (type == 'xlsx' || type == 'xls') {
                set_type(type);
                // setLoading(true)
                // console.log(loading)
                setTimeout(() => {
                    set_modal_file(true);
                }, [2000])
                // setLoading(false)
            } else if (type == 'pdf') {
                set_modal_pdf(true);
            } else if (type == 'docx' || type == 'doc') {
                getWord(item.file_id);
                set_modal_word(true);
            } else if (file_type == 'audio') {
                set_modal_mp3(true)
            } else {
                set_modal_ppt(true);
            }

        }
    }
    const getWord = (file_id) => {
        axios
            .get('/cramSchool/api/file/docx', { params: { file_id: file_id } })
            .then((response) => {
                setContent(response.data.content)
            })
    }
    const handleEditWord = (file_id) => {
        axios
            .post('/cramSchool/api/file/docx', { content: content, file_id: file_id })
            .then((response) => {
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        // content: label_language.Common.children.edit_error[language],
                        content: '修改失敗',
                    });
                } else {
                    messageApi.open({
                        type: 'success',
                        // content: label_language.Common.children.edit_success[language],
                        content: '修改成功',
                    });
                }
                set_modal_word(false)
            })
    }
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    useEffect(() => {
        setDataTmp(data)
        setLoading(false)
    }, [data])
    const handleAllDelete = () => {
        const deleterow = [{ "file_id": selectedRowKeys }];
        axios
            .patch('/media/api/classify_structure_type_file_delete', deleterow)
            .then((response) => {
                if (response.data.status == 'failure') {
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.delete_error[language],
                    });
                    reloadPage();
                } else {
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.delete_success[language],
                    });
                    reloadPage();
                }
            })
    }
    // useEffect(() => {
    //     console.log(dataTmp)
    // }, [dataTmp])
    return (
        <>
            {contextHolder}
            <PreviewMp3Modal
                open={modal_mp3}
                setOpen={set_modal_mp3}
                file={file}
                file_url={dataurl}
            />
            <PreviewWordModal
                open={modal_word}
                setOpen={set_modal_word}
                file={file}
                file_url={url}
                content={content}
                setContent={setContent}
                handleEdit={handleEditWord}
            />
            <PreviewPdfModal
                open={modal_pdf}
                setOpen={set_modal_pdf}
                file={file}
                file_url={url}
            />
            <PreviewModal
                open={modal_file}
                setOpen={set_modal_file}
                type={type}
                file={file}
                file_url={url} />
            <PreviewImgModal
                download={true}
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                file={file}
                img={url}
            ></PreviewImgModal>
            <PreviewVideoModal
                open={modal_video}
                setOpen={set_modal_video}
                file={file}
                file_url={dataurl}
            />
            <PreviewPPTModal
                open={modal_ppt}
                setOpen={set_modal_ppt}
                file={file}
                file_url={url}
            />
            <Col span={24}>
                <Row gutter={[8, 8]} justify={'end'}>
                    <Col>
                        <Popconfirm
                            placement="topRight"
                            title='確定刪除嗎？'
                            onConfirm={e => handleAllDelete()}
                            okText="確定"
                            cancelText="取消"
                        >
                            <span style={{
                                cursor: 'pointer', color: '#fff',
                                backgroundColor: '#53b7ad',
                                borderRadius: '6px',
                                padding: '8px'
                            }}>刪除</span>
                        </Popconfirm>
                    </Col>
                    {/* <Space> */}
                    <Col span={24} style={{ maxWidth: '100%', minWidth: '100%' }}>
                        <Table
                            // width={'100%'}
                            rowSelection={rowSelection}
                            columns={[{
                                title: '檔案名稱',
                                dataIndex: 'file_client_name',
                                render: (_, record, text) =>
                                    <>
                                        <Avatar shape="square" size="large" src={record.dataurl} />
                                        {record.file_client_name}
                                    </>,
                                width: '45%',
                                sorter: (a, b) => a.file_client_name.length - b.file_client_name.length,
                            }, {
                                title: '上傳人',
                                dataIndex: 'upload_user_name',
                                width: '20%',
                                sorter: (a, b) => a.upload_user_name.length - b.upload_user_name.length,
                            }, {
                                title: '上傳時間',
                                dataIndex: 'upload_time',
                                width: '20%',
                                sorter: (a, b) => moment(a.upload_time).unix() - moment(b.upload_time).unix()
                            }, {
                                title: '',
                                width: '15%',
                                render: (_, record, text) =>
                                    <>
                                        <Row justify={'space-around'}>
                                            <Col><EditOutlined
                                                className='example'
                                                style={{
                                                    // backgroundColor: '#F9D4E5',
                                                    color: 'blue',
                                                    fontSize: '1rem',
                                                    borderRadius: '50%',
                                                    padding: '8px'
                                                }}
                                                onClick={e => { handleEdit(record.file_type, record.file_id, record) }}
                                            /></Col>
                                            <Col>
                                                <Popconfirm
                                                    placement="topRight"
                                                    title='確定刪除嗎？'
                                                    onConfirm={e => handleDeleteRow(record.file_id)}
                                                    okText="確定"
                                                    cancelText="取消"
                                                >
                                                    <DeleteOutlined
                                                        className='example'
                                                        style={{
                                                            // backgroundColor: '#F9D4E5',
                                                            color: 'red',
                                                            fontSize: '1rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                    />
                                                </Popconfirm></Col>
                                        </Row>
                                    </>
                            }]}
                            dataSource={dataTmp}
                            pagination={{
                                pageSize: 8,
                                total: total,
                                page: page,
                                //設定頁數
                                // onChange: (page) => console.log(page),
                            }}
                            // pagination={false}
                            loading={loading}
                            rowKey={'file_id'}
                            onRow={(record, rowIndex) => {
                                return {
                                    onClick: (event) => {
                                        handlePreview(record.file_type, record.file_extension_tmp, record)
                                    }, // click row
                                };
                            }}
                            style={{ cursor: 'pointer' }}
                            scroll={{ x: '100%' }}
                            tableLayout='fixed'
                            onChange={handleOnChange}
                        />
                    </Col>
                </Row >
                {/* </Space> */}
            </Col >
        </>
    )
}
export default MediaList;
